module.exports = __webpack_public_path__ + "static/img/156_TO8_1879.bf85deb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/156_TO8_1879.jpg
// module id = 9EeF
// module chunks = 0